import { getFileExtension } from '../../../utils/getFileExtension'
import { FileType } from '../types'

export const getFileType = (src: string): FileType => {
  const fileExtension = getFileExtension(src)
  return fileExtension === 'pdf' ? FileType.Pdf : FileType.Image
}
